import type { FaireProductEntity } from "../../entity_types/product";

export const p_970pfwg424: FaireProductEntity = {
  token: "p_970pfwg424",
  type: "product",
  name: "Makeup Remover with Micellar Water – Gentle, Travel-friendly",
  brandToken: "b_129dsr49u5",
  brandName: "Taylor Made Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/a2375ab890236aa78ed07fdb1b61457726d99d19ad0a7dad6ac8ee63d23ccbf7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d80d0a1bbb49d7926c6f5de2a9a929cdbbfa787ae1c0938008c808974729102a.png",
    "https://cdn.faire.com/fastly/1fadc7c6b7e358173a1bdb84d33eb74fffe964ed71081dbbccd35dc88a77277a.png",
  ],
  priceDollars: 10,
  description:
    "Gentle micellar water makeup remover for sensitive skin. Removes stubborn eye makeup without drying. Vegan, clean formula. 4 oz + 1 oz free.\n\nSay goodbye to harsh removers and hello to clean, refreshed skin with our Makeup Remover with Micellar Water. Specially designed for even the most sensitive skin types, this gentle formula lifts away stubborn eye makeup, foundation, dirt, and oil—without stripping or drying your skin.\n\nInfused with witch hazel water, glycerin, and organic grapefruit essential oil, it cleanses while keeping skin hydrated and balanced. Perfect for daily use, on-the-go touch-ups, or travel, this remover makes taking off makeup quick, easy, and irritation-free.\n\nRemoves even waterproof & long-wear makeup\nGentle on sensitive skin, safe for eyes\nNon-drying formula leaves skin fresh & soft\nVegan | Paraben-Free | Phthalate-Free | Glycol-Free | Gluten-Free\nMade with certified organic grapefruit essential oil\n\n4 oz flip-top bottle + 1 oz free (limited time)\n\nHow to use: Apply to a cotton pad. Hold over closed eyes for 3–5 seconds, then wipe gently. Repeat as needed. Avoid harsh rubbing.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:57.055Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
